import React, { Component } from 'react';

class InputField extends Component{
    render(){
        const {value,onChangeHandler,placeholder,name,autoComplete,className} = this.props;
        return <input type="text" name={name} className={className} placeholder={placeholder} value={value} onChange={onChangeHandler} autoComplete={autoComplete?"off":""}/>
    }
}

export default InputField;